import React, { useEffect, useState } from 'react';
import Loader from "../../../components/Loader"; 
import Paginator from "../../../components/Paginator"; 
import ApiService from "../../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link  } from 'react-router-dom';
import DateRangePicker from "../../../components/DateRangePicker";


const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: "",
        daterange: "",
        page: 1,
    });
 
    
    useEffect(() => {
        getUsers();
    }, [apiData.page, apiData.search, apiData.daterange]); // Dependency array for re-fetching data

    const getUsers = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/system-users",
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setUsers(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: '',
            page: 1
        });
    };

    const delData = async (id) => {
        // Check if user is super user (shouldn't happen due to UI, but double check)
        const user = users.find(u => u._id === id);
        if (user && user.is_super_user) {
            toast.error('Super user cannot be deleted');
            return;
        }

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `admin/system-users/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getUsers();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        // Check if user is super user
        const user = users.find(u => u._id === id);
        if (user && user.is_super_user) {
            toast.error('Super user cannot be deactivated');
            return;
        }

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `admin/system-users/status/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getUsers();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">{("System Users")}</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/admin/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">{("System Users")}</li>
                        </ul>
                    </div>
                    <div className="d-flex align-users-center gap-2 gap-lg-3">
                        {/* Add New users Button */}
                        <Link to={`/admin/system-users/create/`} className="btn btn-sm btn-base">
                               Add New
                        </Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-users-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder={("Search User name, email..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <DateRangePicker
                                                value={apiData.daterange}
                                                onChange={(daterange) => setApiData({ ...apiData, daterange, page: 1 })}
                                                placeholder="Select Date Range"
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{('clear')}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_users_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>{("Image")}</th>
                                                <th>{("Name")}</th>
                                                <th>{("Email")}</th>
                                                <th>{("Role")}</th>
                                                <th>{("Status")}</th>
                                                <th>{("Actions")}</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {users.length > 0 ? users.map((cat, index) => (
                                                <tr key={index}>
                                                    <td> <img src={cat.picture} alt="logo" className='w-50px h-50px rounded-circle' /> </td>
                                                    <td>
                                                        {cat.name}
                                                        {cat.is_super_user && (
                                                            <span className="badge badge-light-warning ms-2">Super User</span>
                                                        )}
                                                    </td>
                                                    <td>{cat.email}</td>
                                                    <td>
                                                        {cat.is_super_user ? (
                                                            <span className="badge badge-light-info">All Permissions</span>
                                                        ) : (
                                                            (cat.role_id && typeof cat.role_id === 'object' ? cat.role_id.name : cat.role_id) || <span className="text-muted">No Role</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span 
                                                                className={`badge ${cat.status ? 'badge-light-success' : 'badge-light-danger'}`} 
                                                                onClick={() => !cat.is_super_user && updateStatus(cat._id)}
                                                                style={{ cursor: cat.is_super_user ? 'not-allowed' : 'pointer' }}
                                                                title={cat.is_super_user ? 'Super user cannot be deactivated' : ''}
                                                            >
                                                                {cat.status ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </button>
                                                    </td>
                                                    <td className="mt-2">
                                                        <Link to={`/admin/system-users/create/${cat._id}`} className="btn btn-sm h-35px btn-light-primary">
                                                            <i className="bi bi-pencil-fill fs-6"></i>
                                                        </Link>
                                                        {!cat.is_super_user && (
                                                            <button onClick={() => delData(cat._id)} className="btn btn-sm h-35px btn-light-danger ms-2">
                                                                <i className="bi bi-trash-fill fs-6"></i>
                                                            </button>
                                                        )}
                                                        {cat.is_super_user && (
                                                            <span className="badge badge-light-warning ms-2" title="Super user cannot be deleted">Protected</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2">No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
